import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Layout from '../Layout';
import { ProductCard, AddProductModal, EditProductModal, ProductCardSkeleton } from './ProductComponent';
import { ProductModal } from '../orders/OrderComponent';
import './product.css';
import { ProductApi } from '../../app/api/product.api';
import productData from "./productData";


export function Product() 
{
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [category, setCategory] = useState("");
  const [subcategory, setSubcategory] = useState("");
  const [name, setName] = useState("");

  const product = ProductApi(); 
  const [filteredData, setFilteredData] = useState([]);
  const [listSubcategories, setlistSubcategories] = useState([]);
  
  const fetchData = async () => { 
    const {data} = await product.findAll();
    return data.data; 
  }
  const { isLoading, data=[], error, refetch } = useQuery({  queryKey: ["products"], queryFn: fetchData });
  
  
  const handleInputs = (event) => {
    const { name, value } = event.target;
    if( name === 'category' ) {
        const selectedCategory = productData.subcategories.find(item => item.category === value);
        setlistSubcategories(selectedCategory ? selectedCategory.listItems : []);
        setCategory(value);
    }
    if( name === 'subcategory' ) {
        setSubcategory(value);
    }
    if( name === 'name' ) {
        setName(value);
    }
  }


  useEffect(() => {
  
      if (!Array.isArray(data)) return;
      let filtered = data;
  
      if (category) filtered = filtered.filter(item => item.category?.toLowerCase() === category.toLowerCase() );
      if (subcategory) filtered = filtered.filter(item => item.subcategory?.toLowerCase() === subcategory.toLowerCase() );
      if (name) filtered = filtered.filter(item => item.name?.toLowerCase().startsWith(name.toLowerCase()) );
     
      setFilteredData(filtered);
  
  }, [data, category, subcategory, name]);  


  const getDetail = ( product ) => {
    setSelectedProduct( product );
    setShowDetailModal(true);
  };


  // Modal handler
  const handleAddNew = () => {
    setShowAddModal(true);
  };

  const handleEdit = (product) => {
    setSelectedProduct(product);
    setShowEditModal(true);
  };



  return (

    <Layout activeMenu={2}>
  
      <div className='container-fluid m-0 bg-white py-5'>
        <div className='row justify-content-center'>
          <div className='col-md-11'>

            <section className='row'>
              <div className='col-12 px-0'>
                 <div className="d-flex flex-column">
                    {/* Fil d'Ariane / Titre */}
                    <div className="bg-light-gray border py-4 text-center">
                      <h1 className="fs-2 text-muted"> Collection produits </h1>
                      <span className="p1 bg-green" style={{ width: '50px' }}> </span>
                    </div>

                    {/* Barre de Filtres et Contrôles */}
                    <div className="container mt-5">
                      <div className="d-flex gap-3 flex-column flex-md-row justify-content-between align-items-center border-bottom pb-3 mb-4">
                        {/* Vue Grille/Liste */}
                        <div className="d-flex align-items-center gap-3 display-controls">
                          <span className="text-muted lead"><i className="bi bi-grid-3x3-gap-fill"></i></span>
                          <span className="text-muted lead"> Liste de nos produits </span>
                        </div>
                        {/* Infos et Tris */}
                        <div className="d-flex align-items-center gap-3 filter-controls">
                          <button title="Ajouter un produit" onClick={handleAddNew} className="btn btn-sm btn-outline-green px-3">
                            <i className="bi bi-plus-circle me-1"> </i> Nouveau produit
                          </button>
                          <a href="/statistiques-produits" className='btn btn-sm btn-outline-dark px-3'> Voir statistiques <i className="bi bi-chevron-right ms-1"></i> </a>
                        </div>
                      </div>

                      {/* Boutons de Filtres Catégories */}
                      <div className="d-flex gap-2 flex-wrap mb-5">
                        <div className="d-flex gap-2 align-items-center">
                          <select className="border w-100 p-2 text-secondary" value={category} name="category" onChange={ handleInputs } required >
                            <option value="">Choisir une catégorie </option>
                            {
                              productData.categories.map((item, index)=> ( 
                                <option value={item.name} key={index}> {item.content} </option> 
                              ))
                            }
                          </select>
                          <select className="border w-100 p-2 text-secondary" name="subcategory" onChange={ handleInputs } required >
                            <option value="">Choisir une sous-catégorie </option>
                            {
                              listSubcategories.map((item, index)=> ( 
                                <option value={item.name} key={index}> {item.content} </option> 
                              ))
                            }
                          </select>
                        </div>
                        {/* SEARCH BAR */}
                        <div className="d-flex align-items-center">
                          <input type="search" className="w-100 px-3 py-2 border text-secondary" placeholder="Rechercher un produit..." value={name} name="name" onChange={ handleInputs } required />
                          <span className="border py-2 px-2"> <i className="bi bi-search text-muted"></i> </span>                 
                        </div>
                      </div>

                    </div>
                  </div>
               </div>
            </section>

            <section className="row">

              {/* Loading */}
              {isLoading && (
                [...Array(4)].map((_, index) => (
                  <ProductCardSkeleton key={index} />
                ))
              )}
              
              {/* Error */}
              {!isLoading && error && (
               <div className="text-center p-4 border alert alert-danger w-100">
                 Une erreur est survenue. Veuillez vérifier votre connexion.
               </div>
              )}
              
              {/* Data */}
              {!isLoading && !error && Array.isArray(filteredData) && filteredData.length > 0 && (
                
                filteredData.map( ( product, index ) => (
                  <ProductCard key={index} product={product} detail={ () => getDetail( product ) } onEdit={ () => handleEdit( product ) } />
                ))
              )}
              
              {/* Liste vide */}
              {!isLoading && !error && Array.isArray(filteredData) && filteredData.length === 0 && (
                <div className="bg-white border p-4 text-center text-secondary w-100">
                  La liste est actuellement vide. Aucun élément n’a été trouvé.
                </div>
              )}
              
            </section>
                
          </div>   
        </div>
      </div>


      {/* Modal d'Ajout de Produit */}
      {
        showDetailModal &&  (
          <ProductModal show={showDetailModal} product={selectedProduct} onHide={() => setShowDetailModal(false)} />
        )
      }

      {/* Modal d'Ajout de Produit */}
      {
        showAddModal && (
          <AddProductModal show={showAddModal} onHide={() => setShowAddModal(false)} refetch={refetch} />
        )
      }
      
      {/* Modal de Modification de Produit */}
      {
        showEditModal && (
          <EditProductModal  show={showEditModal}  onHide={() => setShowEditModal(false)}  product={selectedProduct} refetch={refetch} />
        )
      }

    </Layout>

  );
        
}